import type { PeriodSportsKeysType } from './types';

import type { tFunction } from 'app/lang';

import dictionary from './Periods.dictionary.json';

export function getFinishedPeriod<T extends PeriodSportsKeysType>(key: T, t: tFunction) {
  return {
    key,
    value: t(dictionary.matchFinished),
  };
}
